/**
 * Shopify PDP to External URL Redirect Script
 * Preserves UTM parameters and detects traffic source (direct/organic/social/referral)
 * 
 * Features:
 * - Preserves all existing UTM parameters (utm_source, utm_medium, utm_campaign, utm_content, utm_term)
 * - Preserves non-UTM query parameters
 * - Detects organic traffic from Google, Bing, etc.
 * - Detects social traffic from Facebook, LinkedIn, Instagram, Twitter
 * - Detects direct traffic and other referrers
 * - Tags all redirects with utm_redirect=shopify_pdp for easy segmentation
 * - Gracefully handles edge cases and malformed URLs
 * - Removes www prefix from captured hostnames for cleaner analytics
 */

(function() {
  'use strict';
  
  function executeRedirect() {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = document.referrer;
    
    let destinationUrl = "https://www.nexplayground.com";
    const params = new URLSearchParams();
    
    // Check if any UTM params exist
    const utmParamNames = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const hasUtmParams = utmParamNames.some(param => urlParams.has(param));
    
    if (hasUtmParams) {
      // ===== PATH 1: UTM Parameters Exist =====
      // Pass through ALL existing parameters (both UTM and non-UTM)
      urlParams.forEach((value, key) => {
        params.append(key, value);
      });
      // Add redirect tracking tag
      params.append('utm_redirect', 'shopify_pdp');
      
    } else {
      // ===== PATH 2: No UTM Parameters - Detect Traffic Source =====
      
      if (!referrer || referrer.trim() === '') {
        // Direct traffic (no referrer)
        params.append('utm_source', 'direct');
        params.append('utm_medium', 'shopify_redirect');
        
      } else if (referrer.includes('google')) {
        // Organic search - Google
        params.append('utm_source', 'google');
        params.append('utm_medium', 'organic');
        
      } else if (referrer.includes('facebook')) {
        // Social traffic - Facebook
        params.append('utm_source', 'facebook');
        params.append('utm_medium', 'social');
        
      } else if (referrer.includes('linkedin')) {
        // Social traffic - LinkedIn
        params.append('utm_source', 'linkedin');
        params.append('utm_medium', 'social');
        
      } else {
        // Generic referrer capture
        try {
          const referrerUrl = new URL(referrer);
          let hostname = referrerUrl.hostname || 'referrer';
          
          // Remove www. prefix for cleaner source names
          if (hostname.startsWith('www.')) {
            hostname = hostname.substring(4);
          }
          
          params.append('utm_source', hostname);
          params.append('utm_medium', 'referral');
          
        } catch (e) {
          // Malformed referrer - fallback
          params.append('utm_source', 'referrer');
          params.append('utm_medium', 'referral');
        }
      }
      
      // Tag all non-UTM traffic as coming from Shopify redirect
      params.append('utm_redirect', 'shopify_pdp');
    }
    
    // Append parameters to destination URL
    if (params.toString()) {
      destinationUrl += "?" + params.toString();
    }
    
    // Execute redirect
    window.location.href = destinationUrl;
  }
  
  // Execute redirect when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', executeRedirect);
  } else {
    executeRedirect();
  }
  
})();
